export default __webpack_public_path__ + "static/media/User-icon.bdbd5350.svg";